import {Box, HStack} from '@chakra-ui/react';
import {ReactNode, useCallback, useState} from 'react';
import {CalendarGrid} from './CalendarGrid';
import {ClientDesc, LivraisonDesc} from 'api-types/ffconnect-hal';
import {State} from '@synako/halitrek';
import {CalendarHeader} from './CalendarHeader';
import {BlueButton} from '@/components/Button/BlueButton';
import {useTranslation} from 'react-i18next';
import {useModal} from '@ebay/nice-modal-react';

export const Calendar: React.FC<{
  onCancel?: () => void;
  onDateSelect: (resource: State<LivraisonDesc>) => void;
  onValidate: () => Promise<unknown>;
  selectedLivraison: State<LivraisonDesc>;
  dateDebut?: Date | undefined;
  children?: ReactNode;
  optionComponent?: ReactNode;
  livraisonsPossiblesBO?: State<LivraisonDesc>[];
  clientBO?: State<ClientDesc>;
  buttonText?: string;
}> = ({
  onDateSelect,
  onValidate,
  selectedLivraison,
  dateDebut,
  children,
  optionComponent,
  livraisonsPossiblesBO,
  clientBO,
  buttonText,
}) => {
  const {t} = useTranslation();
  const [monthOffset, setMonthOffset] = useState<number>(0);

  const onDateClick = useCallback(
    (livraison: State<LivraisonDesc>) => {
      onDateSelect(livraison);
      setMonthOffset(0);
    },
    [onDateSelect, setMonthOffset],
  );

  const modal = useModal();
  const [validating, setValidating] = useState(false);
  const valideThenClose = () => {
    setValidating(true);
    onValidate()
      .then(() => {
        // TODO : gérer ici une gestion des erreurs ?
        // modal.hide();
        modal.remove();
      })
      .finally(() => {
        setValidating(false);
      });
  };
  return (
    <Box>
      <CalendarHeader
        dateLivraison={selectedLivraison.data.tolede.date_de_livraison}
        monthOffset={monthOffset}
        setMonthOffset={setMonthOffset}
      />
      <CalendarGrid
        selectedLivraison={selectedLivraison}
        onDateClick={onDateClick}
        monthOffset={monthOffset}
        dateDebut={dateDebut}
        livraisonsPossiblesBO={livraisonsPossiblesBO}
        clientBO={clientBO}
      />
      {children}

      {/* Checkbox pour aussi différer le panier (uniquement visible en BO) */}
      {optionComponent && (
        <HStack
          justifyContent='flex-start'
          w='100%'
          ml='5px'
        >
          {optionComponent}
        </HStack>
      )}

      {/* FOOTER */}
      <HStack
        mt={{
          base: optionComponent ? '1' : '5',
          md: optionComponent ? '2' : '10',
        }}
        gap='3'
        flexDirection={{base: 'column', md: 'row'}}
        alignItems='stretch'
        bottom='50px'
        p='5px'
      >
        <BlueButton
          texte={buttonText ?? t('modale_livraison.changer_date')}
          isDisabled={validating}
          onClick={valideThenClose}
          flex='1'
          p='3'
          flexShrink={0}
          mt='0'
        />
      </HStack>
    </Box>
  );
};
